import React, {useState} from "react";
import {CheckBox as CheckBoxIcon, CheckBoxOutlineBlank as CheckBoxOutlineBlankIcon} from "@mui/icons-material";
import {Autocomplete, Checkbox, Chip, Divider, Grid, TextField} from "@mui/material";
import {useMst} from "../../../../../mobx";
import {observer} from "mobx-react-lite";
import {Controller, useFormContext} from "react-hook-form";
import {IQuestionForm, SubquestionForm} from "../../../QuestionForm";
import {requiredQuestionTopicMessage} from "../../../../../validation/question/errors";
import {requiredFieldRule} from "../../../../../validation/question/rules";

interface QuestionAutocompleteTopicsProps {
	prefix?: string
}

export default observer(function QuestionAutocompleteTopics({ prefix }: QuestionAutocompleteTopicsProps) {
	const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
	const checkedIcon = <CheckBoxIcon fontSize="small" />;
	const { topicsStore } = useMst();
	const [loading, setLoading] = useState(false);
	const { getTopics, getTopicsData } = topicsStore;
	const { control } = useFormContext<IQuestionForm | SubquestionForm>();

	const onOpen = async () => {
		setLoading(true);
		await getTopics()
		setLoading(false);
	}

	return (
		<Controller
			control={control}
			name={`${prefix}topics`}
			defaultValue={[]}
			{...requiredFieldRule()}
			render={({ field: { value , onChange }, fieldState: { error } }) => (
				<Autocomplete
					value={value}
					onChange={(_, value) => onChange(value)}
					multiple
					fullWidth
					loading={loading}
					loadingText={"Загрузка..."}
					noOptionsText={"Нет опций"}
					onOpen={onOpen}
					disableCloseOnSelect
					renderInput={(params) => (
						<TextField
							{...params}
							variant="outlined"
							margin={"dense"}
							size={"small"}
							label={"Темы"}
							placeholder={"Выберите тему"}
							error={!!error}
							helperText={requiredQuestionTopicMessage(error)}
						/>
					)}
					getOptionLabel={(option) => option.title}
					renderTags={(values, getTagProps) =>
						values.map((value, i) =>
							<Chip color={"primary"} size={"small"} variant={"outlined"} label={value.title} {...getTagProps({ index: i })} />)
					}
					renderOption={(props, option, { selected }) => (
						<li {...props} key={option.title + option.id}>
							<Grid container wrap={"nowrap"} alignItems={"center"}>
								<Grid item>
									<Checkbox icon={icon} checkedIcon={checkedIcon} checked={selected} />
								</Grid>
								<Grid item>
									{option.title}
								</Grid>
							</Grid>
							<Divider sx={theme => ({ margin: theme.spacing(1, 0) })}/>
						</li>
					)}
					options={getTopicsData}
				/>
			)}
		/>
	);
});
